  import React, { useState, useEffect } from "react";
import { Select, Avatar, Checkbox, Tag, Spin } from "antd";
import { PhoneOutlined, LoadingOutlined } from '@ant-design/icons';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL, DateFormat } from '../Components/Constant';
import { colors, getUniqueColor } from '../Components/Utility';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

const DynamicSelect = (
  {
    objectName,
    lookupConfig,
    onSearch,
    value,
    name,
    lookupOptionforparent,
    fieldId,
    onChange,
    disabled,
    isFieldReadOnly
  }) => {


  const [fields, setFields] = useState([]);
  const [recentRecords, setRecentRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const [isSearchingLoading, setIsSearchingLoading] = useState(false);
  const [currency, setCurrency] = useState('');
  const defaultCurrency = useSelector(state => state.data.orgItem);

  const fetchOrgSetupDetails = async () => {

    setCurrency(defaultCurrency?.currency);

  };

  useEffect(() => {
    fetchOrgSetupDetails();

  }, []);

  const fetchOptions = async () => {
    try {
      const objectService = new ApiService(`${BASE_URL}/mt_fields/object/${objectName}`, {}, 'GET');
      const response = await objectService.makeCall();
      setFields(response);
    } catch (error) {
    }
  };

  const fetchRecentRecords = async () => {
    try {
      setLoading(true); // Start loading
      const recentService = new ApiService(
        `${BASE_URL}/recent_view/${objectName}`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const response = await recentService.makeCall();
      setRecentRecords(response || []);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch recent records", error);
      setLoading(false);
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {
    fetchRecentRecords();
  }, [objectName]);

  useEffect(() => {
    fetchOptions();
  }, []);

  const renderField = (type, fieldValue) => {
    switch (type) {
      case 'boolean':
        return <Checkbox checked={fieldValue} disabled />;
      case 'currency':
        return `${currency || '$'}${fieldValue !== undefined && fieldValue !== null ? parseFloat(fieldValue).toFixed(2) : ''}`;
      case 'formula':
      case 'string':
        return fieldValue || '';
      case 'date':
        return fieldValue ? dayjs(fieldValue).format(DateFormat) : '';
      case 'datetime':
        return fieldValue ? dayjs(fieldValue).utc().format('DD/MM/YYYY hh:mm A') : ''; // Format DateTime as DD/MM/YYYY HH:mm:ss
      case 'percentage':
        return `${fieldValue !== undefined && fieldValue !== null ? parseFloat(fieldValue) : ''}%`;
      case 'integer':
        return fieldValue !== undefined && fieldValue !== null ? fieldValue : '';
      case 'decimal':
        return fieldValue !== undefined && fieldValue !== null ? fieldValue : '';
      case 'email':
        return fieldValue ? <a href={`mailto:${fieldValue}`}>{fieldValue}</a> : '';
      case 'url':
        return fieldValue ? (
          <a
            href={fieldValue.startsWith('http') ? fieldValue : `http://${fieldValue}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {fieldValue}
          </a>
        ) : '';
      case 'address':
        return fieldValue
          ? [fieldValue.street, fieldValue.city, fieldValue.state, fieldValue.postal_code, fieldValue.country]
            .filter(Boolean)
            .join(', ')
          : '';

      case 'phone':
        return fieldValue ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <PhoneOutlined style={{ marginRight: 8 }} />
            {fieldValue || ''}
          </div>
        ) : '';
      case 'multiselect':
        return Array.isArray(fieldValue) ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px' }}>
            {fieldValue.map((value, index) => (
              <Tag key={index}
                color={getUniqueColor(index)}
                style={{
                  fontSize: '12px', // Increase font size
                  padding: '4px 10px', // Adjust padding for larger size
                  borderRadius: '8px', // Add rounded corners for better aesthetics
                  lineHeight: '1.5', // Adjust line height for better spacing
                }}
              >
                {value}
              </Tag>
            ))}
          </div>
        ) : (
          fieldValue || ''
        );

      case 'richtext':
        return fieldValue ? (
          <div
            style={{
              padding: '12px',
              fontSize: '14px',
              color: '#555',
              maxHeight: '200px', // Limits the height of the field
              overflowY: 'auto',  // Adds a vertical scrollbar if content exceeds the maxHeight
              wordBreak: 'break-word', // Ensures long words break correctly
              whiteSpace: 'normal', // Ensures text wraps properly
              border: '1px solid #ddd', // Optional: Adds a border for clarity
              borderRadius: '4px', // Optional: Rounds the edges
              width: '700px', // Sets the width of the field
              maxWidth: '100%', // Ensures the width does not exceed the container
            }}
            dangerouslySetInnerHTML={{ __html: fieldValue }} // Use dangerouslySetInnerHTML here
          />
        ) : '';


      default:
        return fieldValue || '';
    }
  };

  const getOptionChildren = (option) => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {option?.image ? (
          <img
            // src={`data:image/png;base64,${option?.image}`}
            src={`${BASE_URL}/ImageUpload/${option?.org_id}/${option?.image}.png`}

            alt="profile"
            style={{
              width: 24, // Avatar small size
              height: 24,
              borderRadius: "50%", // circular
              objectFit: "cover",
              marginRight: 6,
            }}
          />
        ) : (
          <Avatar size="small" style={{ backgroundColor: "#87d068", marginRight: 6 }}>
            {option?.Name?.charAt(0).toUpperCase()}
          </Avatar>
        )}

        {option?.Name}
      </div>
    );
  };


  const getOptionLabel = (option) => (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
      <div style={{ display: "flex", alignItems: "center" }}>

        {option?.image ? (
          <img
            // src={`data:image/png;base64,${option?.image}`}
            src={`${BASE_URL}/ImageUpload/${option?.org_id}/${option?.image}.png`}

            alt="profile"
            style={{
              width: 24, // Avatar small size
              height: 24,
              borderRadius: "50%", // circular
              objectFit: "cover",
              marginRight: 6,
            }}
          />
        ) : (
          <Avatar size="small" style={{ backgroundColor: "#87d068", marginRight: 6 }}>
            {option?.Name?.charAt(0).toUpperCase()}
          </Avatar>
        )}
        {option.Name}
      </div>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
        {lookupConfig?.display_fields?.map((fieldKey, index) => {
          // Find the matching field in the state
          const matchedField = fields.find((field) => field.name === fieldKey);

          // Get field type and value
          const fieldType = matchedField?.type; // Default to "text" if not found
          const value =
            typeof option[fieldKey] === "object" && option[fieldKey] !== null
              ? Object.values(option[fieldKey]).join(" ") // Join object values with space
              : option[fieldKey] || ""; // Display value or fallback to empty string

          return (
            <div
              key={fieldKey}
              style={{
                fontSize: "12px",
                color: "#888",
                marginRight:
                  index < lookupConfig?.display_fields.length - 1 ? 8 : 0, // Add margin except for the last item
              }}
            >

              {renderField(fieldType, value)}
            </div>
          );
        })}

      </div>
    </div>
  );

  return (
    <Select
      allowClear
      showSearch
      placeholder="Type to search"
      disabled={disabled || isFieldReadOnly === true}
      suffixIcon={loading ? <Spin indicator={<LoadingOutlined spin />} /> : null}
      onSearch={(searchValue) => {
        setIsSearching(Boolean(searchValue));
        setIsSearchingLoading(true);
        onSearch(searchValue, fieldId, name, () => setIsSearchingLoading(false));
      }}
      onChange={(selectedValue, optionNode) => {
        // Find the original record object from your options
        const allOptions = isSearching
          ? (lookupOptionforparent[name] || [])
          : recentRecords;

        const recordObj = allOptions.find(opt => opt._id === selectedValue);

        // Call onChange with (selectedValue, optionNode, recordObj)
        onChange && onChange(selectedValue, optionNode, recordObj);

        console.log("onChange", selectedValue, optionNode, recordObj);
      }}
      optionLabelProp="children"
      filterOption={false}
      value={value}
      notFoundContent={isSearchingLoading ? <Spin indicator={<LoadingOutlined spin />} /> : "No records found"}
      options={(
        isSearching
          ? [
            ...(lookupOptionforparent[name] || []).map((option) => ({
              children: getOptionChildren(option),
              value: option._id,
              label: getOptionLabel(option),
            })),
            ...(value &&
              !(lookupOptionforparent[name] || []).some((option) => option._id === value._id)
              ? [
                {
                  children: getOptionChildren(value),
                  value: value._id,
                  label: getOptionLabel(value),
                },
              ]
              : []),
          ]
          : [
            ...recentRecords.map((option) => ({
              children: getOptionChildren(option),
              value: option._id,
              label: getOptionLabel(option),
            })),
            ...(value &&
              !(lookupOptionforparent[name] || []).some((option) => option._id === value._id)
              ? [
                {
                  children: getOptionChildren(value),

                },
              ]
              : []),
          ]
      )}


      onDropdownVisibleChange={(open) => {
        if (!open) {
          setIsSearchingLoading(false);
        }
      }}
    />
  );
};

export default DynamicSelect;